import { ConnectionData } from '../types/api';

class AuthService {
  private static instance: AuthService;
  private isAuthenticated: boolean = false;
  private tokenKey = 'auth_token';

  private constructor() {
    // Check if connection data exists in localStorage
    if (this.getToken()) {
      this.isAuthenticated = true;
    }
  }

  public static getInstance(): AuthService {
    if (!AuthService.instance) {
      AuthService.instance = new AuthService();
    }
    return AuthService.instance;
  }

  public isUserAuthenticated(): boolean {
    return this.isAuthenticated;
  }

  public setConnectionData(data: ConnectionData): void {
    localStorage.setItem('connection_info', JSON.stringify(data));
    // this.isAuthenticated = true;
  }
  public removeConnectionData(): void {
    localStorage.removeItem('connection_info');
  }

  public getConnectionData(): ConnectionData | null {
    const data = localStorage.getItem('connection_info');
    return data ? JSON.parse(data) : null;
  }

  public disconnect(): void {
    // localStorage.removeItem('connection_info');
    this.removeToken();
    this.isAuthenticated = false;
  }

  getToken(): string | null {
    return localStorage.getItem(this.tokenKey);
  }

  setToken(token: string): void {
    localStorage.setItem(this.tokenKey, token);
    this.isAuthenticated = true;
  }

  removeToken(): void {
    localStorage.removeItem(this.tokenKey);
    localStorage.removeItem('connection_info');
  }

  logout(): void {
    this.removeToken();
    // You can add additional logout logic here, like redirecting to login page
    window.location.href = '/setup-connection';
  }
}

export const authService = AuthService.getInstance(); 